module.exports = __webpack_public_path__ + "static/media/mini.22905cf6.png";